export default __webpack_public_path__ + "static/media/icon_twitter.a0faf589.webp";